import { MatchTrackBase } from "model/Match/Track/MatchTrack";
import { KnockoutRound } from "./KnockoutRound";
import { getKnockoutRoundResultDisplayScore } from "./KnockoutRoundResult";

export type KnockoutTrack = MatchTrackBase & {
  rounds: KnockoutRound[];
};

export const getKnockoutTrackRosterDisplayScore = (
  track: KnockoutTrack,
  rosterId: string
) => {
  for (let i = track.rounds.length - 1; i >= 0; i--) {
    const round = track.rounds[i];
    const result = round.results.find((r) => r.rosterId === rosterId);
    if (!result) {
      continue;
    }

    return getKnockoutRoundResultDisplayScore(result);
  }

  return undefined;
};
